import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AwsRum, type AwsRumConfig } from "aws-rum-web";

try {
  const APPLICATION_ID = process.env.REACT_APP_RUM_APP_MONITOR_ID;
  const IDENTITY_POOL_ID = process.env.REACT_APP_RUM_IDENTITY_POOL_ID;

  if (APPLICATION_ID && IDENTITY_POOL_ID) {
    const config: AwsRumConfig = {
      sessionSampleRate: 1,
      identityPoolId: IDENTITY_POOL_ID,
      endpoint: "https://dataplane.rum.eu-west-2.amazonaws.com",
      telemetries: ["performance", "errors", "http"],
      allowCookies: true,
      enableXRay: false,
      signing: true,
    };

    new AwsRum(APPLICATION_ID, "1.0.0", "eu-west-2", config);
  }
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
